module.exports = __webpack_public_path__ + "img/restaurant_card_image05.989f37fa.jpg";